import locale from "localization";
import Validation from "utils/validation.utils";

const initialState = (orderSummary) => {
  return {
    purchaseOrderNumber: {
      name: "purchaseOrderNumber",
      value: orderSummary?.order?.purchaseOrderNumber || "",
      label: locale.purchaseOrderNo,
      maxLength: 75,
      required: true,
      validations: [Validation.required()],
    },
    salesOrderNumber: {
      name: "salesOrderNumber",
      value: orderSummary?.order?.salesOrderNumber || "",
      label: locale.salesOrderNo,
      maxLength: 75,
      required: true,
      validations: [Validation.required()],
    },
    reason: {
      name: "reason",
      value: "",
      label: locale.reason,
      placeholder: locale.select,
      dirty: false,
    },
    reasonRemarks: {
      name: "reasonRemarks",
      value: "",
      label: locale.remarks,
      placeholder: locale.sampleRemarks,
      maxLength: 500,
      dirty: false,
    },
    remarksHo: {
      name: "remarksHo",
      value: orderSummary?.order?.remarksHo || "",
      label: locale.remarksHo,
      placeholder: locale.sampleRemarks,
      maxLength: 500,
      validations: [Validation.alphaNumeric()],
    },
    orderItems: {
      name: "orderItems",
      value:
        orderSummary?.order?.orderItems?.length > 0
          ? orderSummary?.order?.orderItems?.map(({ orderItemId, amount, productCode }) => ({
              orderItemId: orderItemId,
              amount: amount,
              productCode: productCode,
            }))
          : [],
      label: locale.witness,
      placeholder: locale.enterName,
      required: true,
      validations: [Validation.required(), Validation.requiredArray({ notEmpty: true })],
    },
  };
};

export default initialState;
